<template>
  <div v-if="item">
    <b-row class="m-0 p-0 justify-content-between" >
      <p class="m-0" :key="item.amount">{{ item.amount }}x
        <font-awesome-icon v-if="item.amount > 0 && !checkOrder" @click="subItem(index)" style="z-index: 2000" class="ml-1 hover h5 m-0 text-danger" :icon="['fas', 'minus-square']"/>
        <font-awesome-icon v-if="item.amount < 10 && !checkOrder" @click="addItem()" style="z-index: 2000" class="ml-2 hover h5 m-0 text-success" :icon="['fas', 'plus-square']"/>
      </p>
      <p class="m-0">{{ item.title }}</p>
      <p class="m-0">{{ getExtrasPrice }}€</p>
    </b-row>
      <b-row class="m-0 justify-content-center my-2" v-b-toggle="'item-'+item._id+index">
        <font-awesome-icon class="when-closed" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-down']"/>
        <font-awesome-icon class="when-open" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-up']"/>
      </b-row>
    <div>
      <div>
        <b-collapse :id="'item-'+item._id+index" >
          <div>
            <b-form-textarea
              v-if="item.note || !checkOrder"
              id="textarea"
              v-model="item.note"
              placeholder="Hinweis für das Restaurant. z.B: Ohne Zwiebeln, mit Käse..."
              rows="2"
              max-rows="6"
              :disabled="checkOrder"
            ></b-form-textarea>
            <div class="mt-2" v-if="item.extras.length > 0 && !checkOrder">
                <b-form-checkbox
                v-for="extra in item.extras" :key="extra.index"
                v-model="extra.choosen"
              >
                <p class="m-0">{{ extra.title }} +{{ calcExtraPrice(extra) }}€</p>
              </b-form-checkbox>
            </div>
            <div class="mt-2" v-if="item.extras.length > 0 && checkOrder">
                <b-form-checkbox
                v-for="extra in item.extras.filter(item => item.choosen)" :key="extra.index"
                v-model="extra.choosen"
                disabled
              >
                <p class="m-0">{{ extra.title }} +{{ calcExtraPrice(extra) }}€</p>
              </b-form-checkbox>
            </div>
            <div class="mt-3" v-for="menuVariant in item.variants" :key="menuVariant.index">
              <p class="m-0">{{ menuVariant.title }}</p>
              <b-form-select :disabled="checkOrder" :state="!menuVariant.choosen ? false : true" v-model="menuVariant.choosen" style="" :options="getOptions(menuVariant)" size="sm" class="mt-2"></b-form-select>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CartItem',

  props: {
    cartItem: null,
    cart: null,
    index: null,
    checkOrder: null
  },
  components: {

  },
  data: () => {
    return {

    }
  },
  watch: {
    
  },
  computed: {
    item(){
      return this.cartItem
    },
    getExtrasPrice(){
      var price = this.item.price * this.item.amount
      this.item.extras.forEach(element => {
        if(element.choosen){
          price += element.price * this.item.amount
          if(this.item.variants.length > 0){
            this.item.variants.forEach(variant => {
              if(variant.choosen){
                price += variant.choosen.extra_price * this.item.amount
              }
            })
          }
        }
      });
      if(this.item.variants){
        if(this.item.variants.find(variant => variant.choosen)){
          this.item.variants.filter(variant => variant.choosen).forEach(element => {
            price += element.choosen.price * this.item.amount
          })
        }
      }
      
      return price.toFixed(2)
    },
  },
  mounted(){
    
  },
  methods: {
    getOptions(variants){

      var array = []
        if(variants){
          variants.variants.forEach(element => {
            array.push({value: element, text: element.title + ' ( +' + element.price.toFixed(2) +'€ )'})
          });
        }
      
      return array.sort( this.compareVariants )
    },

    calcExtraPrice(extra){
      var price = extra.price * this.item.amount

      if(this.item.variants.length > 0){
        this.item.variants.forEach(variant => {
          if(variant.choosen){
            price += variant.choosen.extra_price * this.item.amount
          }
        })
      }

      return price.toFixed(2)
    },
    addItem(){
      if(this.item.amount >= 10) return
      this.item.amount += 1
    },
    subItem(index){
      this.item.amount -= 1
      
      if(this.item.amount <= 0){
        this.cart.splice(index, 1)
      }
    },
    
  }
}
</script>

<style lang="scss" >

  .outer-preview {
    display: table;
    position: relative;
    top: 0;
    left: 0;
    height: 200px;
    width: 100%;
  }

  .middle-preview {
    display: table-cell;
    vertical-align: middle;
  }

  .inner-preview {
    margin-left: auto;
    margin-right: auto;
  }

  .cart-regular {
    border-radius: 20px;
    position: relative;
    min-height: 120px;
    max-height: 200px
  }

  .cart-details {
    cursor: pointer;
    border-bottom-left-radius: 20px;
    border-top-right-radius: 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 35px;
    position: absolute;
  }
  
  .cart-rating {
    bottom: 40px;
    left: 0;
    height: 35px;
    position: absolute;

      p {
        margin-top: 10px
      }
  }

  .cart-distance {
    bottom: 0;
    left: 50%;
    width: 50%;
    height: 35px;
    position: absolute;
  }
</style>
